export const STORE_HOSTS = [
  "secondlifeappliances.com",
  "www.secondlifeappliances.com",
];

export const APP_CONTEXTS = new Set([
  "backoffice",
  "capture",
  "scanner",
  "tech",
  "wiring",
  "store",
]);

export function appContextFromLocation(location = window.location) {
  const requested = new URLSearchParams(location.search).get("app");
  if (requested && APP_CONTEXTS.has(requested)) {
    return requested;
  }
  if (
    STORE_HOSTS.includes(location.hostname) ||
    location.pathname.startsWith("/store")
  ) {
    return "store";
  }
  if (location.pathname.startsWith("/scanner")) {
    return "scanner";
  }
  if (
    location.pathname.startsWith("/box/") ||
    location.pathname.startsWith("/shelf/")
  ) {
    return "scanner";
  }
  if (location.pathname.startsWith("/capture")) {
    return "capture";
  }
  if (location.pathname.startsWith("/tech")) {
    return "tech";
  }
  if (location.pathname.startsWith("/wiring")) {
    return "wiring";
  }
  return "backoffice";
}

export function appSessionKey(location = window.location) {
  return `owlico-authenticated:${appContextFromLocation(location)}`;
}

export function appLoginPath(location = window.location) {
  const context = appContextFromLocation(location);
  const next = `${location.pathname}${location.search}${location.hash}`;
  return `/login?app=${encodeURIComponent(context)}&next=${encodeURIComponent(next)}`;
}

export function appHome(context = appContextFromLocation()) {
  const homes = {
    backoffice: "/backoffice/me",
    capture: "/capture",
    scanner: "/scanner",
    tech: "/tech",
    wiring: "/wiring",
    store: "/store",
  };
  return homes[context] || homes.backoffice;
}

export function isAppRoute(path, context) {
  const routes = {
    backoffice: [
      "/",
      "/backoffice",
      "/catalog",
      "/inventory",
      "/sales",
      "/admin",
    ],
    capture: ["/capture"],
    scanner: ["/scanner", "/box/", "/shelf/"],
    tech: ["/tech"],
    wiring: ["/wiring"],
    store: ["/store"],
  };
  return (routes[context] || []).some((route) => {
    return route === "/" ? path === "/" : path.startsWith(route);
  });
}
